/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */


export const gdsSpacing10 = "2px";
export const gdsSpacing20 = "4px";
export const gdsSpacing40 = "8px";
export const gdsSpacing100 = "12px";
export const gdsSpacing200 = "16px";
export const gdsSpacing250 = "18px";
export const gdsSpacing300 = "20px";
export const gdsSpacing350 = "24px";
export const gdsSpacing450 = "32px";
export const gdsSpacing550 = "40px";
export const gdsSpacing600 = "48px";
export const gdsSpacing650 = "56px";
export const gdsSpacing700 = "64px";
export const gdsSpacing750 = "72px";
export const gdsSpacing800 = "80px";
export const gdsSpacing850 = "96px";
export const gdsSpacing1000 = "128px";
export const gdsSpacing1100 = "144px";
export const gdsSpacing1300 = "192px";
export const gdsSpacing3xs = "2px";
export const gdsSpacing2xs = "4px";
export const gdsSpacingXs = "8px";
export const gdsSpacingS = "12px";
export const gdsSpacingM = "16px";
export const gdsSpacingL = "18px";
export const gdsSpacingXl = "20px";
export const gdsSpacing2xl = "24px";
export const gdsSpacing3xl = "32px";
export const gdsSpacing4xl = "40px";
export const gdsSpacing5xl = "48px";
export const gdsSpacing6xl = "56px";
export const gdsSpacing7xl = "64px";
export const gdsSpacing8xl = "72px";
export const gdsSpacing9xl = "80px";
export const gdsSpacing10xl = "96px";
export const gdsSpacing11xl = "128px";
export const gdsSpacing12xl = "144px";
export const gdsSpacing13xl = "192px";
